import axios from "axios";
import axiosRetry from "axios-retry";
import { errorNotifier } from "./interceptors";

const MarketingWordPressApi = axios.create({
  baseURL: `${process.env.VUE_APP_WORDPRESS_BASE}`,
  withCredentials: false,
  crossDomain: true,
  insecureHTTPParser: true,
  timeout: 15000,
});

axiosRetry(MarketingWordPressApi, {
  retryDelay: axiosRetry.exponentialDelay,
  retries: 2,
});

MarketingWordPressApi.interceptors.response.use(
  (response) => response,
  (error) => {
    errorNotifier(error);
  },
);

export default MarketingWordPressApi;
